var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid"
                  }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Información General" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.formFields.activo.label,
                                  color: "success",
                                  "persistent-hint": "",
                                  hint: _vm.mensajeEstado,
                                  readonly: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.activo.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.activo,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.activo.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md12: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|max:80",
                                    expression: "'required|max:80'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.nombre.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.nombre.id
                                  ),
                                  "data-vv-name": _vm.formFields.nombre.id,
                                  counter: 80,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.nombre.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.nombre,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.nombre.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Script" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md12: "" } },
                            [
                              _c("CodeView", {
                                attrs: { readOnly: _vm.modoVer },
                                on: { blur: _vm.handleBlur },
                                model: {
                                  value: _vm.valorScript,
                                  callback: function($$v) {
                                    _vm.valorScript = $$v
                                  },
                                  expression: "valorScript"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }